import type { ShareClientRequest } from '@/types/clientDetailsApiTypes';
import type { EmailFormData } from '../../modals/ShareViaEmailModal/types';

type BuildShareClientPayloadParams = {
  values: EmailFormData;
  attachmentMediaUuids?: string[];
};

export const buildShareClientPayload = ({
  values,
  attachmentMediaUuids,
}: BuildShareClientPayloadParams): ShareClientRequest => ({
  share_profile: values.selectedForms.includes('profile'),
  share_credit_card: values.selectedForms.includes('credit_card'),
  email: values.email,
  cc: values.cc_email,
  bcc: values.bcc_email,
  message: values.message ?? '',
  ...(values.signature !== null && { signature: values.signature }),
  ...(attachmentMediaUuids && { attachment_media_uuids: attachmentMediaUuids }),
});
